import { createAction, createAsyncAction } from 'eight.js.store-common';

export const signupAsync = createAsyncAction('@@auth/SIGNUP');

export const setAuthInternalFetching = createAction('@@auth/SET_INTERNAL_FETCHING');

export const setAdminAccessToken = createAction('@@auth/SET_ADMIN_ACCESS_TOKEN');
